$(document).ready(function() {
  // Toggle sidebar
  $('.open-sidebar').on('click', function() {
    toggleSidebar();
  });

  function toggleSidebar() {
    $('.main-sidebar-area').toggleClass('actived');
    $('#chat-button').toggleClass('hide');
    $('body').toggleClass('sidebar-open');
  }

  // Discover item click event
  $('#discover-item').on('click', function() {
    $('.discover-area').css('display', 'block');
    $('.sidebar-first').css('display', 'none');
    $('#back-nav').css('visibility', 'visible');
  });

  // Back nav click event
  $('#back-nav').on('click', function() {
    $('.discover-area').css('display', 'none');
    $('.sidebar-first').css('display', 'block');
    $('#back-nav').css('visibility', 'hidden');
  });

  // Close nav click event
  $('#close-nav').on('click', function() {
    toggleSidebar();
  });

  // Sidebar-main-item click event
  $('.sidebar-main-item').on('click', function() {
    const hiddenCards = $(this).find('.card-selections');
    clearCardSelection();
    hiddenCards.css('visibility', 'visible');
  });

  function clearCardSelection() {
    $('.card-selections').css('visibility', 'hidden');
  }
});
